import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function PercentageCircleIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M6 5.66667C6.18409 5.66667 6.33333 5.51743 6.33333 5.33333C6.33333 5.14924 6.18409 5 6 5C5.81591 5 5.66667 5.14924 5.66667 5.33333C5.66667 5.51743 5.81591 5.66667 6 5.66667Z"
        fill="currentColor"
      />
      <path
        d="M10.3333 10.6667C10.3333 10.8508 10.1841 11 10 11C9.8159 11 9.66667 10.8508 9.66667 10.6667C9.66667 10.4826 9.8159 10.3333 10 10.3333C10.1841 10.3333 10.3333 10.4826 10.3333 10.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667ZM11.0202 4.97978C10.825 4.78452 10.5084 4.78452 10.3131 4.97978L4.65626 10.6366C4.461 10.8319 4.461 11.1485 4.65626 11.3437C4.85152 11.539 5.1681 11.539 5.36337 11.3437L11.0202 5.68689C11.2155 5.49162 11.2155 5.17504 11.0202 4.97978ZM6 6.66667C6.73638 6.66667 7.33333 6.06971 7.33333 5.33333C7.33333 4.59695 6.73638 4 6 4C5.26362 4 4.66667 4.59695 4.66667 5.33333C4.66667 6.06971 5.26362 6.66667 6 6.66667ZM11.3333 10.6667C11.3333 11.403 10.7364 12 10 12C9.26362 12 8.66667 11.403 8.66667 10.6667C8.66667 9.93029 9.26362 9.33333 10 9.33333C10.7364 9.33333 11.3333 9.93029 11.3333 10.6667Z"
        fill="currentColor"
      />
    </svg>
  )
}
